import React from 'react';
import './PracticeAreas.css';
import { 
  LuBuilding2, 
  LuUsers, 
  LuShieldCheck, 
  LuBriefcase,  
  LuScale 
} from "react-icons/lu"; // Using Lucide React icons for the gold symbols

import { FiHome } from "react-icons/fi";

const PracticeAreas = () => {
  const areas = [
    { title: "Corporate Law", icon: <LuBuilding2 /> },
    { title: "Family Law", icon: <LuUsers /> },
    { title: "Criminal Defence", icon: <LuShieldCheck /> },
    { title: "Employment Law", icon: <LuBriefcase /> },
    { title: "Real Estate Law", icon: <FiHome /> },
    { title: "Civil Litigation", icon: <LuScale /> },
  ];

  return (
    <section className="practice-section" id='practice-areas'>
      {/* Floating Chatbot */}
      <div className="chatbot-btn">
        <div className="chatbot-icon">🤖</div>
        <span>Chatbot</span>
      </div>

      <div className="container">
        <div className="header-badge">Our Experties</div>
        <h2 className="section-title">Practice Areas</h2>
        <p className="section-subtitle">
          Comprehensive legal services across multiple practice areas, delivered with
          expertise and dedication
        </p>

        <div className="practice-grid">
          {areas.map((area, index) => (
            <div key={index} className="practice-card">
              <div className="card-icon">{area.icon}</div>
              <h3 className="card-title">{area.title}</h3>
              <p className="card-text">
                Comprehensive legal services across multiple practice areas, 
                delivered with expertise and dedication
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;